<script>
import AgacMenu from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import store from "@/state/store"; 

import {
  GenericComputed,
  MethodsStrGet,
  MethodsStrPost,
  MethodsStrPut,
  MethodsStrDelete,
  MethodsStrFilterGet,
} from "@/state/helpers";

export default {
  components: {
    AgacMenu,
  },
  props: [
    "multiple",
    "BirimTipId",
    "YetkiKontrol",
    "title",
    "title_class",
    "sutun",
    "selected",
  ],
  data: () => ({
    value: [],
    deneme:null,
    children: [],
    options: [],
    birimlist: [],
    veri: [],
    Userid:"",
    Uygulamaid:"",
    Filter:"",
    clearable: true,
    searchable: true,
    disabled: false,
    openOnClick: true,
    openOnFocus: false,
    clearOnSelect: true,
    alwaysOpen: false,
    appendToBody: false,
    sortValueBy: "ORDER_SELECTED", //LEVEL , INDEX
    valueConsistsOf: "ALL", // "BRANCH_PRIORITY", "LEAF_PRIORITY","ALL_WITH_INDETERMINATE"
    rtl: false,
    flat: false,
    limit: 0,
    Page: {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1",
    },
  }),
  methods: {
    ...MethodsStrGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrDelete,
    ...MethodsStrFilterGet,

    Get() {
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      };

  this.Userid = store.getters["auth/TokenUserId"] 
    
    let Filter = "&Kisaadi=STR";

    this.ActionsFilterGet({Service: "Ouygulama",  Page:Page,Filter:Filter}).then((res) => {
      if(res){

      this.Uygulamaid=res.Data[0].Id;

      this.options=[];



      if (this.Userid != null && this.Uygulamaid != null) {

           if(this.YetkiKontrol==1) this.Filter = "&Userid=" + this.Userid +"&Uygulamaid="+this.Uygulamaid ;


            this.Filter +=  "&GetProgramlarVeBolumler=true" + this.Filter

            this.ActionsFilterGet({Service:"OBirim/GetTreeByAnaBirim", "Page":Page, Filter:this.Filter}).then((res) => {
                let tumu = [];
                tumu.push({ id: 1, label: "Tümü", children: null });
                let gelen_veri=JSON.stringify(res.Data);

                let silinecek='"children":null,'
                gelen_veri=gelen_veri.replaceAll(silinecek,"");

                tumu[0].children = JSON.parse(gelen_veri);
                this.options = tumu;    

                      this.value = this.selected; 


            });                                                         

      } else {

            this.ActionsFilterGet({"Service":"OBirim/GetTreeByAnaBirim", "Page":Page, Filter: "&GetProgramlarVeBolumler=true"}).then((res) => {
                let tumu = [];
                tumu.push({ id: 1, label: "Tümü", children: null });
                let gelen_veri=JSON.stringify(res.Data);

                let silinecek='"children":null,'
                gelen_veri=gelen_veri.replaceAll(silinecek,"");

                tumu[0].children = JSON.parse(gelen_veri);
                this.options = tumu;    

                      this.value = this.selected;

            });
      
      }

      }
    });

    },

  },
  computed: {
    ...GenericComputed,
  },
  whatch: {

    selected() {
      this.value = this.selected;

    },

    Userid(){
      this.Get();
    }

  },
  created() {
    this.value = this.selected;

    this.Get();

   
  },
};
</script>
<template>
  <div class="mb-3">


    <b-form-group
      :class="title_class"
      id="gbirimler"
      :label-cols-lg="sutun"
      :label="title"
      label-for="text"
    >

   <!-- :limit="limit"
        :limitText="count => `${count} kayıt secildi`"  -->
        
      <AgacMenu
        :multiple="multiple"
        :options="options"
        :flat="false"
        :sort-value-by="sortValueBy"
        :default-expand-level="1"
        placeholder="Birim Seçiniz"
        :clearable="clearable"
        :searchable="searchable"
        :disabled="disabled"
        :open-on-click="openOnClick"
        :open-on-focus="openOnFocus"
        :clear-on-select="clearOnSelect"
        :always-open="alwaysOpen"
        :append-to-body="appendToBody"
        :allow-clearing-single="true"
   
        :max-height="200"
        v-model="value"
        label="deneme"
        :input="$emit('Secilmis_Idler', value)"
        :rtl="rtl"
        :value-consists-of="valueConsistsOf"
      />
      <treeselect-value :value="value" />
    </b-form-group>



  </div>

  
</template>
